/**
 * 
 * Reset password page
 * 
 */

import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useSelector, useDispatch } from "react-redux"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import {
    Container,
    Row,
    Col,
    // Button,
    Card,
    CardBody,
    Label,
    Button,
    Input,
} from "reactstrap"
import { withRouter } from "react-router-dom"

import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import * as passwordAction from "../../store/UmVzZXRQYX/actions"
import { isEmpty } from "lodash"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
import { styles } from "../../pages/ClientDetails/Input-Select/select"
import BootstrapTable from "react-bootstrap-table-next"
import Modal from "react-bootstrap/Modal"

const ResetPasswordDetails = (props) => {
    const title = "Reset Password"

    const { dispatch } = props
    const specificDispatch = useDispatch()

    console.log("specificDispatch..", specificDispatch)

    //const { SearchBar } = Search

    useEffect(() => {
        dispatch(permissionAction.loadEmployee())
    }, [1])

    const update = useSelector((specificstate) => specificstate)

    console.log("update is", update)
    const permissionUpdate = useSelector(
        (specificstate) => specificstate.resetpassword
    )
    const {
        passwordData = []
    } = permissionUpdate

    const processUpdate = useSelector((specificstate) => specificstate.permissionrequest)
    const {  employee_list = [] } = processUpdate
    //dropdown options api
    const employeeList =
        !isEmpty(employee_list) &&
        employee_list.map((employee) => {
            return {
                _id: employee._id,
                empCode: employee.empCode,
                name: employee.name,
                companyId: employee.companyId,
                roleId: employee.roleId,
            }
        })

    const createOptions = (array) => {
        const options = []
        !isEmpty(array) &&
            array.forEach((element) => {
                const labelEmployee = element.empCode.concat(" - ", element.name)
                // [...element.empCode,...element.name].join('')

                let obj = {}
                obj.value = element._id
                obj.empCode = element.empCode
                obj.label = labelEmployee
                obj.companyId = element.companyId
                obj.roleId = element.roleId
                options.push(obj)
            })
        return options
    }

    const employeeOptions = createOptions(employeeList)
    //dropdown list
    const [employeeCode, setEmployeeCode] = useState([])
    const [modal, setModal] = useState(false)
   // const[showpassword,setShowpassword] = useState(false)
    const [btnLoader, setBtnLoader] = useState(false)
    const [viewTable,setViewTable] = useState(false)
  
    const resetForm = () => {
        setEmployeeCode([])
        setViewTable(false)
    }
    const applyfilter = ()=>{
        var searchEmployee =
        employeeCode && employeeCode.empCode ? employeeCode.empCode : ""
        var searchValue = {}
        if (searchEmployee) {
            searchValue.empCode = searchEmployee
          }
          console.log("searchCompany", searchValue)
          if(!isEmpty(searchValue)){
          specificDispatch(passwordAction.loadRecordsMetaData(searchValue))
          setViewTable(true)
          setBtnLoader(true)
          setTimeout(() => {
            setBtnLoader(false)
          }, 2000)}
    }

    
    const passwordDataTable =viewTable&&!isEmpty(passwordData)
    ? passwordData.map((data, index) => { 
         const password = data.base64Password
        return {
            _id: data._id,
            branch: data.branchName,
            company:data.companyName,
            department:data.departmentName,
            designation:data.designationName,
            employeeCode: data.empCode,
            employeeName:data.name,
            password: (<div style={{display:"flex"}}>
                <Input type = "password" value = {password} onChange={(e)=>{console.log(e)}} id ="myInput"/>
                <span className ="p-viewer">
                    <i className="fas fa-eye icon-btn" 
                    onClick={()=>{var x =  document.getElementById("myInput")
                    if (x.type === "password") {
                        x.type = "text"
                      } else {
                        x.type = "password"
                      }
                }}
                     style = {{marginLeft:"-30px",cursor:"pointer",marginTop:"10px"}} ></i></span>
               </div>
            ),
            resetPassword: (
                <Button
                    type="submit"
                    onClick={() => {
                        setModal(true)
                        editModal(data)
                    }}
                    className="btn btn-warning"
                    style={{ fontSize: "13px" }}           
                >
                    Reset Password
                </Button>
            ),
            key: index,
        }
    }):[]

 //pagination table data columns
 const columns = [
    {
        dataField: "company",
        text: "Company",
        sort: true,
        headerStyle: {
            minWidth: "130px",
        },
    },
    {
        dataField:  "branch",
        text: "Branch",
        sort: true,
        headerStyle: {
            minWidth: "120px",
        },
    },
    {
        dataField:  "department" ,
        text: "Department",
        sort: true,
        headerStyle: {
            minWidth: "130px",
        },
    },
    {
        dataField: "designation",
        text: "Designation",
        sort: true,
        headerStyle: {
            minWidth: "130px",
        },
    },
    {
        dataField: "employeeCode",
        text: "Code",
        sort: true,
        headerStyle: {
            minWidth: "90px",
        },
    },
    {
        dataField:  "employeeName",
        text: "Employee Name",
        sort: true,
        headerStyle: {
            minWidth: "160px",
        },
    },
    {
        dataField: viewTable? "password":null,
        text: "Password",
        sort: true,
        headerStyle: {
            minWidth: "160px",
        },
    },
    {
        dataField:"resetPassword",
        text: "Reset Password",
        sort: true,
        headerStyle: {
            minWidth: "160px",
        },
    },
]
const [modalData,setModalData] = useState({
    empId:""
})

  const editModal = (data) =>{
    setModalData({...modalData,
        empId:data._id,
    })
  }

  const resetFunction = () =>{
    const changeData ={
        "employeeId":modalData.empId
    }
    console.log("mychecking",changeData)
    specificDispatch(passwordAction.changePassword(changeData))
    setTimeout(() => {
        setModal(false)
      },500)
  }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>{title} | Zero Gravity CRM</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title={"Master"} breadcrumbItem={title} />

                    <Row>
                        <Col xs={12}>
                            <Card>
                                 <CardBody>
                                    <form>
                                        <Row>
                                            <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                                                <div className="d-flex justify-content-between">
                                                    <Label
                                                        className={"form-label"}
                                                        htmlFor={"Employee Code - Name"}
                                                    >
                                                        {"Employee Code - Name"}
                                                    </Label>
                                                </div>
                                                <Select
                                                    type="autocomplete"
                                                    name="employeeCode"
                                                    value={employeeCode}
                                                    isClearable
                                                    closeMenuOnSelect={true}
                                                    onChange={(e) => setEmployeeCode(e)}
                                                    styles={styles}
                                                    options={employeeOptions}
                                                    placeholder="Enter Employee Code"
                                                />
                                            </Col>
                                            <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                            <div style={{marginTop:"27px",float: "left"}}>
                                                    <Button
                                                        type="button"
                                                        onClick={() => applyfilter()}
                                                        className="btn btn-info btn-label simple-form-applyfilter-btn"
                                                    >
                                                        <i className="bx bx-search label-icon"></i>
                                                        {btnLoader && btnLoader ? (
                                                      <ButtonSpinner />
                                                           ) : (
                                                      "Search"
                                                          )}{" "}
                                                    </Button>
                                                    &nbsp;&nbsp;
                                                    <Button
                                                        type="button"
                                                        onClick={() => resetForm()}
                                                        className="btn btn-danger btn-label simple-form-Reset-btn"
                                                    >
                                                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                                                        Reset
                                                    </Button>
                                                    </div>
                                        </Col>
                                        </Row>
                                    </form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card>
                                <CardBody>
                                    <BootstrapTable keyField='_id' data={ passwordDataTable } columns={ columns }  striped />
                                 
                                </CardBody>
                            </Card>
                        </Col>

                        {modal && (
                            <Modal show={modal} size="md" >
                                <Modal.Header
                                    style={{
                                        backgroundColor: "#E40D8C",
                                        color: "white",
                                        minHeight: "65px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                    }}
                                >
                                   
                                        <p className="text-nowrap">Are you sure you want to reset your password?</p>
                                   
                                </Modal.Header>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        className="btn btn-danger"
                                        onClick={() =>
                                            setModal(false)

                                        }
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="btn btn-success"
                                        onClick={() =>
                                        resetFunction()
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        )}
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

ResetPasswordDetails.propTypes = {
    dispatch: PropTypes.func,
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}
const mapStateToProps = () => ({})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ResetPasswordDetails)
)
